export const enum Environment {
    Local = 'LOCAL',
    Dev = 'DEV',
    Stage = 'STAGE',
    Prod = 'PROD',
}

function getEnvironment(): Environment {
    if (window.location.host.startsWith('localhost') || window.location.host.startsWith('192.168')) return Environment.Local;
    if (window.location.host.endsWith('.dev')) return Environment.Dev;
    if (window.location.host.startsWith('stage.') || window.location.host.includes('.stage.')) return Environment.Stage;
    return Environment.Prod;
}

export const environment: Environment = getEnvironment();
